import { Col, Container, Row } from "react-bootstrap";
import MaterialIcon, {
  MtIcon,
} from "../../../../../shared/oversight-core/ui-elements/material-icon/material-icon";
import SpinnerModal from "../../../../../shared/oversight-core/ui-elements/spinner/spinner";
import style from "./estimation-summary-view-card.module.scss";

interface ISummaryItem {
  count: number;
  title: string;
  onClick?: () => void;
  iconColor: string;
  isLoading?: boolean;
  icon: MtIcon;
  selected?: boolean;
}

interface IProps {
  data: ISummaryItem[];
}

const EstimationSummary = ({ data }: IProps) => {
  return (
    <Container className={`${style.estimationSummaryCardContainer} p-2`}>
      <Row className="g-2">
        {data.map((item, idx) => (
          <Col key={idx} xs={12} sm={6} md={3}>
            <div
              className={`${
                item.selected ? `bg-side-bar` : style.estimationSummaryCard
              } cursor-pointer p-2 rounded-3 gap-2 d-flex align-items-center h-100`}
              onClick={item.onClick}
            >
              <div>
                <MaterialIcon
                  icon={item.icon}
                  color={item.iconColor}
                  size={18}
                />
              </div>
              <div>
                {item.isLoading ? (
                  <SpinnerModal show={item.isLoading} withOverlay={false} />
                ) : (
                  <span className="title-2 font-weight-600 font-size-16">
                    {item.count}
                  </span>
                )}
              </div>
              <div className="font-size-14 text-color-2 font-weight-400">
                {item.title}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default EstimationSummary;
